class CartToggle {}

export default CartToggle



// WEBPACK FOOTER //
// ./scripts/components/CartToggle.js